export function setAndroidAppLanguage(lang){
  window.androidApp.setLanguage(lang)
  // calling kotlin function named setLanguage()    
}
export function setIOSAppLanguage(lang){
  
}
